module.exports = __webpack_public_path__ + "static/media/AoA_Map_BG.e1610c07.jpg";